import { parseTemplate } from 'url-template';
import mapPagination from '~/Api/Pagination/mapPagination';
import Pagination from '~/Api/Pagination/Pagination';
import mapProduct, { type RawProduct } from '~/Api/Product/mapProduct';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import Item from './Item';

export interface Result {
	items: Item[];
	pagination: Pagination;
}

export default function findUserGroupProducts(
	client: ApiClient,
	userId: string,
	groupId: string,
	page: number,
	perPage: number
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products{?page,perPage}');

	return client
		.fetch(url.expand({ userId, groupId, page, perPage }))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(
				(item: { product: RawProduct; packageSizeForSingleUnit?: number }) =>
					new Item(mapProduct(item.product || item), item.packageSizeForSingleUnit || null)
			),
			pagination: mapPagination(response.pagination),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
